import type * as React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { SingleSizeIllustrationHeroVisibilityPost } from '@xing-com/illustrations';
import { BodyCopy } from '@xing-com/typography';

import { Styled } from './view-counter-modal.style';

export type ViewCounterModalProps = {
  viewsCount: number;
};

export const ViewCounterModal: React.FC<ViewCounterModalProps> = ({
  viewsCount,
}) => {
  const { formatMessage, formatNumber } = useIntl();
  const formattedViewCounts = formatNumber(viewsCount);

  return (
    <Styled.ViewCounterDetail>
      <Styled.DetailLeftSide>
        <SingleSizeIllustrationHeroVisibilityPost />
      </Styled.DetailLeftSide>
      <Styled.DetailRightSide>
        <Styled.ViewCounterHeading size="large" sizeConfined="xlarge">
          <FormattedMessage id="SOCIAL_BAR_VIEW_COUNTER_HEADING" />
        </Styled.ViewCounterHeading>
        <BodyCopy size="medium">
          <FormattedMessage id="SOCIAL_BAR_VIEW_COUNTER_DESCRIPTION" />
        </BodyCopy>
        <BodyCopy>
          <FormattedMessage
            id="SOCIAL_BAR_VIEW_COUNTER_SEEN"
            values={{
              views: formattedViewCounts,
              strong: (viewsCount) => <strong>{viewsCount}</strong>,
            }}
          />
        </BodyCopy>
        <BodyCopy>
          <FormattedMessage
            id="SOCIAL_BAR_VIEW_COUNTER_TIP"
            values={{
              a: (chunks) => (
                <a
                  target="_blank"
                  rel="noreferrer noopener"
                  href={formatMessage({ id: 'XING_FAQ_GUIDE_URL' })}
                >
                  {chunks}
                </a>
              ),
              strong: (chunks) => <strong>{chunks}</strong>,
            }}
          />
        </BodyCopy>
      </Styled.DetailRightSide>
    </Styled.ViewCounterDetail>
  );
};
